import Donors from "components/Donors";
import "style.css";

const socials = [
  {
    href: "https://www.instagram.com/mizzousurf/",
    src: "/images/connectUsIcon/Instagram_icon.png",
    alt: "Instagram",
  },
  {
    href: "https://www.linkedin.com/company/mizzsurf/",
    src: "/images/connectUsIcon/linkedin_icon.svg",
    alt: "LinkedIn",
  },
  {
    href: "https://engage.missouri.edu/feeds?type=club&type_id=35895&tab=about",
    src: "/images/connectUsIcon/engage_icon.jpg",
    alt: "MU Engage",
  },
  {
    href: "https://github.com/MUsurf",
    src: "/images/connectUsIcon/github_icon.svg",
    alt: "GitHub",
  },
];

const Contact = () => {
  return (
    <div className="contact-page">
      <section className="contact-hero">
        <h1 className="contact-heading">Connect With Us</h1>

        <div className="contact-social-row">
          <img
            className="officerGroupPhoto"
            src="/images/officers/OfficersGroup.jpg"
            alt="SURF officers group"
            loading="lazy"
          />
          <div className="contact-social-links">
            {socials.map((s) => (
              <a
                key={s.alt}
                href={s.href}
                target="_blank"
                rel="noreferrer"
                className="contact-social-item"
              >
                <img src={s.src} alt={s.alt} className="social-icon" />
                <span className="contact-social-label">{s.alt}</span>
              </a>
            ))}
          </div>
        </div>

        <p className="contact-email-label">Or reach us by email:</p>
        <a
          href={`mailto:${process.env.REACT_APP_CONTACT_EMAIL || "muengrsurf@missouri.edu"}`}
          className="contact-email-link"
        >
          {process.env.REACT_APP_CONTACT_EMAIL || "muengrsurf@missouri.edu"}
        </a>
      </section>

      <section className="contact-sponsor">
        <h2 className="contact-sponsor-heading">Interested in Sponsoring?</h2>
        <p className="contact-sponsor-body">
          We're always looking for partners who share our passion for
          engineering and innovation. Download our sponsor package to learn more
          about how you can support Mizzou SURF.
        </p>
        <a
          href="/sponsor_package.pdf"
          target="_blank"
          rel="noreferrer"
          className="contact-sponsor-btn"
        >
          Download Sponsor Package
        </a>
      </section>

      <Donors />

      <footer className="contact-footer">
        <p
          style={{
            color: "var(--color-text-muted)",
            fontSize: "12px",
            margin: 0,
          }}
        >
          © 2025 Mizzou SURF
        </p>
      </footer>
    </div>
  );
};

export default Contact;
